import { useLocation } from "react-router-dom";
import parse from "html-react-parser";
function ViewProfile() {
  const location = useLocation();
  const { profile } = location.state || {};
  return (
    <>
      <style>
        {`
        .view-profile {
            margin-top: 80px;
            margin-bottom: 100px;


            img {
                border-radius: 8px;
            }

            h1 {
                color: var(--alrajhi-Brand-1000, #000045);
                font-family: "Ping AR + LT";
                font-size: 45px;
                font-style: normal;
                font-weight: 700;
                line-height: 130%; /* 58.5px */
                letter-spacing: -1.035px;
            }


            h2 {
                color: var(--gray-500-body-text, #72788E);
                font-feature-settings: 'liga' off, 'clig' off;
                font-family: "Ping AR + LT";
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }

            p {
                color: var(--gray-500-body-text, #72788E);
                font-family: "Ping AR + LT";
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%; /* 24px */
                letter-spacing: -0.368px;
            }
        
        }
        @media (max-width: 540px) {
          .view-profile {
              img{
                max-width: 100%;
              }
            }
        }
        `}
      </style>

      <div className="container view-profile">
        <img src={profile.image} alt="roger-full" />

        <div style={{ height: "32px" }}></div>
        <h1>{profile.name}</h1>
        <div style={{ height: "8px" }}></div>
        <h2>{profile.position}</h2>
        <div style={{ height: "24px" }}></div>
        <p>
          
        {parse(profile.biography)}
        </p>
        <div></div>
      </div>
    </>
  );
}

export default ViewProfile;
